<template>
    <div class="layout__padding-clear layout__width-100">

        <el-form :model="searchParams" status-icon :rules="rules" ref="searchParams">
            <div class="layout__padding-clear text__align-center layout__width-100">
                <div class="layout__search-field__admin-orders">
                    <p class="layout__margin__bottom-10">Freetext Search</p>
                        <el-form-item prop="orderFreeText">
                            <el-input placeholder="Search" v-model="searchParams.orderFreeText"
                                      clearable
                                      autofocus></el-input>
                        </el-form-item>
                </div>
                <div class="layout__search-field__admin-orders">
                    <p class="layout__margin__bottom-10">Product</p>

                    <el-form-item prop="orderSource">
                        <el-input placeholder="Search" v-model="searchParams.orderSource">BESPOKE</el-input>
                    </el-form-item>
                </div>
                <div class="layout__search-field__admin-orders">
                    <p class="layout__margin__bottom-10">Assigned To</p>
                    <el-form ref="products">
                        <el-form-item prop="search">
                            <el-select v-model="searchParams.assignment" placeholder="Assigned To" clearable filterable :disabled="this.searchParams.orderSource !== 'BESPOKE'">
                                <el-option v-for="user in users"
                                           :key="user.name"
                                           :label="user.name"
                                           :value="user.name">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="layout__search-field__admin-orders">
                    <p class="layout__margin__bottom-10">Territory</p>
                    <el-form ref="products">
                        <el-form-item prop="search">
                            <el-select v-model="searchParams.territory" placeholder="Territory" clearable filterable>
                                <el-option v-for="territory in territories"
                                           :key="territory.name"
                                           :label="territory.name"
                                           :value="territory.name">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="layout__search-field__admin-orders">
                    <p class="layout__margin__bottom-10">Status</p>
                    <el-form ref="jobStatus">
                        <el-form-item prop="search">
                            <el-select v-model="searchParams.orderStatus" placeholder="Order Status" clearable>
                                <el-option v-for="status in ravensworth.bespokeStatus.options"
                                           :key="status.id"
                                           :label="status.text"
                                           :value="status.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="layout__search-field__admin-orders">
                    <p class="layout__margin__bottom-10">To - From Date</p>
                    <el-form-item prop="salesDateRange">
                        <el-date-picker
                                v-model="searchParams.salesDateRange"
                                type="daterange"
                                range-separator="To"
                                start-placeholder="Start date"
                                end-placeholder="End date"
                                format="dd-MM-yyyy"
                                value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                </div>
            </div>

        </el-form>
        <div class="layout__display-block layout__margin__bottom-10">
            <el-button class="button-red layout__position-center button__base layout__width-150px" v-on:click="getOrders('searchParams')">Search Bespoke
            </el-button>
        </div>



        <el-button class="layout__display-none" id="getBespokeOrdersPagination" v-on:click="getPaginatedResults()">Search Customers
        </el-button>

        <el-button :disabled="false" class="button-teal layout__position-right button__base__admin layout__width-200px"
                   id="downloadAllResults" v-on:click="downloadAllResults()" :loading="downloadLoading">Download Data (csv)
        </el-button>

        <div class=" layout__position-right layout__padding-5-10">
            <p>{{this.resultsCount}} Results Found</p>
        </div>
    </div>

</template>

<script>

    import Axios from 'axios';
    import {axios} from '@/mixins/Axios.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import {csvDownloadHelper} from '@/mixins/CsvDownloadHelper.js';
    import {backing} from '@/mixins/Backing.js';
    import moment from 'moment';

    export default {
        name: "adminOrdersSearch",
        mixins: [axios, dataFormatter, backing, csvDownloadHelper],
        props: {
            searchParams: Object,
            orders: Array,
            loading: Boolean,
            resultsCount: String
        },
        data() {
            return {
                jobStatus: '',
                queryRouteUrl: `${process.env.VUE_APP_ACCOUNTSAPIHOST}/Search/adminSearchbespoke?`,
                parameters: [],
                serviceRouteUrl: `${process.env.VUE_APP_ACCOUNTSAPIHOST}`,
                queryOptions: [],
                downloadLoading: false,
                freetextQueryOptions: [],
                additionalOptions: [],
                resourcePath: '/odata/Bespoke?$filter=',
                queryConcatAnd: '+and+',
                queryConcatOr: '+or+',
                finalQuery: '',
                territories: [],
                users: [],
                exportDate: new Date().toLocaleDateString('en-GB') + '_bespoke_orders.csv',
                pickerOptions: {
                    shortcuts: [{
                        text: 'Today',
                        onClick(picker) {
                            const start = new Date();
                            start.setTime(start.getTime());
                            picker.$emit('pick', start);
                        }
                    },
                        {
                            text: 'Last week',
                            onClick(picker) {
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                picker.$emit('pick', start);
                            }
                        },
                        {
                            text: 'Last month',
                            onClick(picker) {
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                                console.log(start.toLocaleDateString('en-GB'))
                                picker.$emit('pick', start);
                            }
                        },
                        {
                            text: 'Last 3 months',
                            onClick(picker) {
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                                picker.$emit('pick', start);
                            }
                        }]
                },
                rules: {
                    salesDateRange: [{
                        required: true,
                        message: 'To/From Dates required',
                        trigger: 'blur'
                    }]
                }
            }
        },
        computed: {
          assignedTo() {
              return this.$parent.searchParams.orderSource;
          }
        },
        watch: {
            assignedTo() {
                console.log(this.$parent.searchParams.orderSource)
                if (this.$parent.searchParams.orderSource !== 'BESPOKE') {
                    this.$parent.searchParams.assignment = null
                }
            }
        },

        created() {
            this.isUserAuthorised();
            // this.searchParams.salesDateRange[0] = moment().subtract(7, 'days').format('YYYY-MM-DD');
            this.searchParams.salesDateRange[0] = moment().format('YYYY-MM-DD');
            this.searchParams.salesDateRange[1] = moment().format('YYYY-MM-DD');

            if (window.sessionStorage.getItem('_bespokeSearch') !== null && typeof window.sessionStorage.getItem('_bespokeSearch') !== 'undefined') {
                this.$parent.searchParams = JSON.parse(window.sessionStorage.getItem('_bespokeSearch'))
            }

            const getTerritories = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/Search/territoryLookup?`
            Axios.get(getTerritories, this.returnHeaderUsingToken())
                .then(response => {
                    this.territories = response.data.value
                })

            const getUsers = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/Search/userLookup?`
            Axios.get(getUsers, this.returnHeaderUsingToken())
                .then(response => {
                    console.log('rifat')
                    console.log(response.data.value)
                    this.users = response.data.value
                })

            this.getResults()
        },
        beforeUpdate() {
            window.sessionStorage.setItem('_bespokeSearch', JSON.stringify(this.$parent.searchParams));
        },

        methods: {
            constructQueryString() {

                this.parameters = []

                let searchTerms = Object.assign({}, this.$parent.searchParams)

                console.log(this.queryRouteUrl)

                if(searchTerms.orderFreeText !== '') {
                    this.parameters.push('freetext=' + searchTerms.orderFreeText)
                }

                if (searchTerms.territory !== null && searchTerms.territory !== "" ) {
                    this.parameters.push('territory=' + searchTerms.territory)
                }

                if ((searchTerms.assignment !== '' && searchTerms.assignment !== null) && searchTerms.orderSource === 'BESPOKE') {
                    this.parameters.push('assignedTo=' + searchTerms.assignment)
                }

                if (searchTerms.orderStatus !== null && searchTerms.orderStatus !== '' && searchTerms.orderStatus !== 'ANY STATUS') {
                    this.parameters.push('status=' + searchTerms.orderStatus)
                }

                this.parameters.push('startDate=' + searchTerms.salesDateRange[0])
                this.parameters.push('endDate=' + moment(searchTerms.salesDateRange[1], 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD'))



            },
            // constructQueryString_old() {
            //
            //     this.queryOptions = []
            //     this.freetextQueryOptions = []
            //
            //     let searchTerms = Object.assign({}, this.$parent.searchParams)
            //
            //     let baseQueryUri = this.serviceRouteUrl + this.resourcePath
            //
            //     if (searchTerms.orderFreeText !== '') {
            //         this.freetextQueryOptions.push('contains(code, \'' + searchTerms.orderFreeText + '\')')
            //         this.freetextQueryOptions.push('contains(zdTicket, \'' + searchTerms.orderFreeText + '\')')
            //         this.freetextQueryOptions.push('contains(Branch, \'' + searchTerms.orderFreeText + '\')')
            //         this.freetextQueryOptions.push('contains(Name, \'' + searchTerms.orderFreeText + '\')')
            //         this.freetextQueryOptions.push('contains(user, \'' + searchTerms.orderFreeText + '\')')
            //         this.freetextQueryOptions.push('contains(salesperson, \'' + searchTerms.orderFreeText + '\')')
            //     }
            //
            //     if (searchTerms.territory !== null && searchTerms.territory !== "" ) {
            //         this.queryOptions.push('contains(salesperson, \'' + searchTerms.territory + '\')')
            //     }
            //
            //     if ((searchTerms.assignment !== '' && searchTerms.assignment !== null) && searchTerms.orderSource === 'BESPOKE') {
            //         this.queryOptions.push('contains(user, \'' + searchTerms.assignment + '\')')
            //     }
            //
            //     if (searchTerms.orderStatus !== null && searchTerms.orderStatus !== '' && searchTerms.orderStatus !== 'ANY STATUS') {
            //         this.queryOptions.push('status+eq+\'' + searchTerms.orderStatus + '\'')
            //     }
            //
            //     this.queryOptions.push('created+gt+' + searchTerms.salesDateRange[0] + 'T00:00:00.000Z')
            //
            //     // if (searchTerms.salesDateRange[0] === searchTerms.salesDateRange[1]) {
            //         // searchTerms.salesDateRange[1] = moment(searchTerms.salesDateRange[1], 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD');
            //         const datePlusOne = moment(searchTerms.salesDateRange[1], 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD');
            //
            //         this.queryOptions.push('created+lt+' + datePlusOne + 'T00:00:00.000Z')
            //     // } else {
            //     //     this.queryOptions.push('ordered+lt+' + searchTerms.salesDateRange[1] + 'T00:00:00.000Z')
            //     // }
            //
            //     if (searchTerms.orderFreeText !== '') {
            //         this.finalQuery = baseQueryUri.concat('(' + this.freetextQueryOptions.join(this.queryConcatOr) + ')', this.queryConcatAnd, this.queryOptions.join(this.queryConcatAnd), '&$orderby=Created desc')
            //     } else {
            //         this.finalQuery = baseQueryUri.concat(this.queryOptions.join(this.queryConcatAnd), '&$orderby=Created desc')
            //     }
            //
            // },
            getResults() {

                this.constructQueryString()

                let getResults = '';
                getResults = this.queryRouteUrl + this.parameters.join('&') + '&skip=' + this.$parent.searchParams.skip + '&top=' + this.$parent.searchParams.top
                console.log('results')
                console.log(getResults)

                this.$parent.loading = true
                Axios.get(getResults, this.returnHeaderUsingToken())
                    .then(response => {

                        // if(response.data.value.length === 0) {
                        //
                        // }
                        this.$parent.orders = []
                        this.$parent.orders = response.data.value
                        // console.log(this.$parent.orders)
                        console.log(this.$parent.orders.length)

                        for (let i = 0; i < this.$parent.orders.length; i++) {
                            this.$parent.orders[i].created = this.$parent.orders[i].created.split("T")[0]
                            // fixme despatchDue and create need formatting but might need a null check

                        }
                        this.$parent.loading = false
                    })
                    .catch(error => {
                        this.$parent.loading = false
                        this.$parent.orders = []
                    })

                let getCounts = '';
                getCounts = this.queryRouteUrl + this.parameters.join('&') + '&count=true&top=0'
                console.log('count')
                console.log(getCounts)

                // this.$parent.loading = true // todo this might be an issue with the true and false
                Axios.get(getCounts, this.returnHeaderUsingToken())
                    .then(response => {
                        console.log(response.data)
                        console.log(response.data['@odata.count'])
                        this.$parent.resultsCount = response.data['@odata.count']

                        // console.log(this.$parent.customers.length)
                        this.$parent.loading = false
                    })
                    .catch(error => {
                        this.$parent.loading = false
                    })
            },
            getOrders(searchParams) {


                this.$refs[searchParams].validate((valid) => {
                    if (valid) {
                        this.$parent.searchParams.skip = 0;
                        this.$parent.searchParams.currentPage = 1;
                        this.getResults()
                    } else {
                        return false;
                    }
                })
            },
            getPaginatedResults() {
                //    todo this method will return getResults without the form validation - might be able to get rid of this
                this.getResults()
            },
            downloadAllResults() {
                //    todo this method will get all results to download
                this.downloadLoading = true

                this.constructQueryString()
                // this.$parent.loading = true
                const downloadAllResultsUri = this.queryRouteUrl + this.parameters.join('&')

                Axios.get(downloadAllResultsUri, this.returnHeaderUsingToken())
                    .then(response => {
                        console.log(response.data.value.length)

                        const fields = [
                            {label: 'Order_Record_Id', value: 'Id'},
                            {label: 'Order_Id', value: 'OrderId'},
                            {label: 'Ordered', value: 'Ordered'},
                            {label: 'Source_Id', value: 'SourceId'},
                            {label: 'Job_Id', value: 'JobId'},
                            {label: 'Type', value: 'Type'},
                            {label: 'ProductCat2', value: 'Category'},
                            {label: 'Status', value: 'Status'},
                            {label: 'Branch', value: 'Branch'},
                            {label: 'Name', value: 'Name'},
                            {label: 'Job_Name', value: 'JobName'},
                            {label: 'Quantity', value: 'Quantity'},
                            {label: 'Product', value: 'Name'},
                            {label: 'Press', value: 'Press'},
                            {label: 'Style', value: 'Style'},
                            {label: 'Paper', value: 'Paper'},
                            {label: 'Value', value: 'BillPrice'},
                            {label: 'Bill_Status', value: 'BillStatus'},
                            {label: 'Territory', value: 'Customer.Territory'},
                            {label: 'Assigned_To', value: 'BespokeSource.User'},
                            {label: 'Zendesk_Id', value: 'BespokeSource.ZdTicket'}
                        ];

                        this.downloadCsv(this.exportDate, fields, response.data.value)
                        this.downloadLoading = false
                    })
            }
        }
    };
</script>